module.exports = __webpack_public_path__ + "img/fr.bf4cae9b.svg";